import { useEffect } from "react";
import { Hero } from "@/components/landing/Hero";
import { Features, Benefits, HowItWorks, Audience } from "@/components/landing/Sections";
import { Cta, Footer } from "@/components/landing/Cta";

export const DarkShell = ({ children, testId }) => (
  <div className="relative min-h-screen overflow-x-hidden bg-[#07090e] text-slate-200" data-testid={testId}>
    <div className="pointer-events-none absolute inset-0">
      <div className="login-orb absolute -left-40 -top-40 h-[560px] w-[560px] rounded-full bg-blue-600/25 blur-[120px]" />
      <div className="login-orb absolute right-[-200px] top-[30%] h-[520px] w-[520px] rounded-full bg-emerald-500/15 blur-[130px]" style={{ animationDelay: "-6s" }} />
      <div className="absolute inset-0 opacity-[0.05]" style={{ backgroundImage: "linear-gradient(#fff 1px,transparent 1px),linear-gradient(90deg,#fff 1px,transparent 1px)", backgroundSize: "56px 56px", maskImage: "radial-gradient(ellipse at 30% 20%, #000 30%, transparent 75%)" }} />
    </div>
    <div className="relative">{children}</div>
  </div>
);

export default function Landing() {
  useEffect(() => { document.title = "Nouvelle CRM · Il CRM della carta fedeltà per la GDO"; }, []);
  return (
    <DarkShell testId="home-page">
      <Hero />
      <Features />
      <Benefits />
      <HowItWorks />
      <Audience />
      <Cta />
      <Footer />
    </DarkShell>
  );
}
